var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"accept":_vm.accept,"http-request":_vm.upload,"show-file-list":false,"multiple":false,"action":"no"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }